import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
    {
        canActivate: [AuthGuard],
        path: '',
        loadChildren: () => import('src/app/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
        ),
        data: {
            title: null,
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'profile',
        loadChildren: () => import('src/app/profile/profile.module').then(
            (m) => m.ProfileModule
        ),
        data: {
            roles: ['admin', 'marketing', 'partner', 'teacher', 'student'],
            title: 'Профил',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'company',
        loadChildren: () => import('src/app/company/company.module').then(
            (m) => m.CompanyModule
        ),
        data: {
            roles: ['partner'],
            title: 'Компания',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'awards',
        loadChildren: () => import('src/app/awards/awards.module').then((m) => m.AwardsModule),
        data: {
            roles: ['admin', 'partner', 'student'],
            title: 'Награди',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'calendar',
        loadChildren: () => import('src/app/calendar/calendar.module').then((m) => m.CalendarModule),
        data: {
            roles: ['admin', 'partner', 'teacher', 'student'],
            title: 'Календар',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'messages',
        loadChildren: () => import('src/app/messages/messages.module').then((m) => m.MessagesModule),
        data: {
            roles: ['admin', 'marketing', 'partner', 'teacher', 'student'],
            title: 'Съобщения',
        }
    }, {
        canActivate: [AuthGuard],
        path: 'careers',
        loadChildren: () => import('src/app/careers/careers.module').then(m => m.CareersModule),
        data: {
            roles: ['student'],
            title: null,
        }
    }, {
        canActivate: [AuthGuard],
        path: 'jobs',
        loadChildren: () => import('src/app/jobs/jobs.module').then((m) => m.JobsModule),
        data: {
            roles: ['admin', 'marketing', 'partner'],
            title: 'Обяви за работа',
        },
    }, {
        canActivate: [AuthGuard],
        path: 'payments',
        loadChildren: () => import('src/app/payments/payments.module').then((m) => m.PaymentsModule),
        data: {
            roles: ['admin', 'partner', 'student'],
            title: 'Плащания',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'groups',
        loadChildren: () => import('src/app/groups/groups.module').then((m) => m.GroupsModule),
        data: {
            roles: ['admin', 'partner', 'teacher', 'student', 'marketing'],
            title: null,
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'homework',
        loadChildren: () => import('src/app/homework/homework.module').then((m) => m.HomeworkModule),
        data: {
            roles: ['admin', 'partner', 'teacher', 'student'],
            title: 'Домашни',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'points',
        loadChildren: () => import('src/app/points/points.module').then((m) => m.PointsModule),
        data: {
            roles: ['admin', 'partner', 'teacher'],
            title: 'Точки',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'attendances',
        loadChildren: () => import('src/app/attendances/attendances.module').then((m) => m.AttendancesModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Събития и записване',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'ebooks',
        loadChildren: () => import('src/app/ebooks/ebooks.module').then((m) => m.EbooksModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Безплатни ресурси и книги',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'store',
        loadChildren: () => import('src/app/store/store.module').then((m) => m.StoreModule),
        data: {
            guest: false,
            title: 'Магазин',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'blog',
        loadChildren: () => import('src/app/blog/blog.module').then((m) => m.BlogModule),
        data: {
            roles: ['admin', 'marketing', 'partner', 'teacher', 'student'],
            title: 'Блог',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'zoom',
        loadChildren: () => import('src/app/zoom/zoom.module').then((m) => m.ZoomModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Zoom',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'videos',
        loadChildren: () => import('src/app/videos/videos.module').then((m) => m.VideosModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Видео клипове',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'materials',
        loadChildren: () => import('src/app/materials/materials.module').then((m) => m.MaterialsModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Материали',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'presentations',
        loadChildren: () => import('src/app/presentations/presentations.module').then((m) => m.PresentationsModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Презентации',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'rooms',
        loadChildren: () => import('src/app/rooms/rooms.module').then((m) => m.RoomsModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Room',
        },
    },
    {
        path: 'certificates',
        loadChildren: () => import('src/app/certificates/certificates.module').then((m) => m.CertificatesModule),
        data: {
            title: 'Сертификати',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'exams',
        loadChildren: () => import('src/app/exams/exams.module').then((m) => m.ExamsModule),
        data: {
            roles: ['admin', 'partner', 'teacher', 'student'],
            title: null,
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'about',
        loadChildren: () => import('src/app/about/about.module').then((m) => m.AboutModule),
        data: {
            roles: ['admin', 'marketing', 'partner', 'student'],
            title: 'Инструкции',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'students',
        loadChildren: () => import('src/app/students/students.module').then((m) => m.StudentsModule),
        data: {
            roles: ['admin', 'partner', 'teacher'],
            title: 'Курсисти',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'administration',
        loadChildren: () => import('src/app/administration/administration.module').then((m) => m.AdministrationModule),
        data: {
            roles: ['admin'],
            title: 'Администрация',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'teachers',
        loadChildren: () => import('src/app/teachers/teachers.module').then((m) => m.TeachersModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Преподаватели',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'partners',
        loadChildren: () => import('src/app/partners/partners.module').then((m) => m.PartnersModule),
        data: {
            roles: ['admin'],
            title: 'Партньори',
        },
    },
    {
        canActivate: [AuthGuard],
        path: 'courses',
        loadChildren: () => import('src/app/courses/courses.module').then((m) => m.CoursesModule),
        data: {
            roles: ['admin', 'partner'],
            title: 'Курсове',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'code-challenge',
        loadChildren: () => import('src/app/code-challenge/code-challenge.module').then((m) => m.CodeChallengeModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Code Challenge',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'collaborators',
        loadChildren: () => import('src/app/collaborators/collaborators.module').then((m) => m.CollaboratorsModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Сътрудници (партньори)',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'slides',
        loadChildren: () => import('src/app/slides/slides.module').then((m) => m.SlidesModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Слайдове',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'tombola',
        loadChildren: () => import('src/app/tombola/tombola.module').then((m) => m.TombolaModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Томбола',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'outreach',
        loadChildren: () => import('src/app/outreach/outreach.module').then((m) => m.OutreachModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Кампании',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'alumni',
        loadChildren: () => import('src/app/alumni/alumni.module').then((m) => m.AlumniModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Alumni',
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'quizzes',
        loadChildren: () => import('src/app/quizzes/quizzes.module').then((m) => m.QuizzesModule),
        data: {
            roles: ['admin', 'marketing'],
            title: 'Тестове',
        }
    },
    {
        path: 'portal',
        loadChildren: () => import('src/app/portal/portal.module').then((m) => m.PortalModule),
        data: {
            title: 'Портал',
            page: 'portal',
            force_default_locale: true,
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'polls',
        loadChildren: () => import('src/app/polls/polls.module').then((m) => m.PollsModule),
        data: {
            roles: ['admin', 'marketing', 'partner'],
            title: 'Анкети',
        }
    },
    {
        path: 'auth',
        loadChildren: () => import('src/app/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'errors',
        loadChildren: () => import('src/app/errors/errors.module').then((m) => m.ErrorsModule),
    },

    {
        path: '**',
        redirectTo: '/errors/404',
    },
];

